// Stand down thumbstick locomotion (smooth move + snap turn) while something
// else owns the sticks — e.g. an arcade game played with the thumbstick as a
// d-pad. Holders are named, so two owners can't release each other's lock.
// VRLocomotion checks this every frame; nothing is lost while it's held.

const holders = new Set<string>();

export function lockLocomotion(who: string) { holders.add(who); }
export function unlockLocomotion(who: string) { holders.delete(who); }
export function locomotionLocked(): boolean { return holders.size > 0; }
